<app-introduction-reseller *ngIf="english"></app-introduction-reseller>
<app-reseller-intro-hindi *ngIf="hindi"></app-reseller-intro-hindi>
